import { ref } from 'vue'
import { fetchCenteredHistory } from '@/api/chat'
import { updateMessage } from '@/store'

export function useCenteredMessage() {
	const loading = ref(false)

	async function load(chatId, messageId) {
		loading.value = true
		try {
			const result = await fetchCenteredHistory(chatId, messageId)
			// fetchCenteredHistory swallows its own errors and returns undefined,
			// so a falsy result means "no data or an already-logged failure".
			if (!result) return null
			updateMessage(messageId, { isHighlighted: true })
			return result
		} catch (e) {
			console.error(e)
			return null
		} finally {
			loading.value = false
		}
	}

	function scrollIntoView(messageId, idPrefix = '') {
		const el = document.getElementById(`${idPrefix}message_${messageId}`)
		if (!el) return false
		el.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' })
		return true
	}

	return { load, scrollIntoView, loading }
}
